import { typedEnv } from '@app/environment/typed-env';
import { DevKitSection } from './DevKitSection';
import { AuthDevKitSection } from './section/AuthDevKitSection';
import { AuthOverrideDevKitSection } from './section/AuthOverrideDevKitSection';
import { EnvOverrideDevKitSection } from './section/EnvOverrideDevKitSection';
import { TranslationDevKitSection } from './section/TranslationDevKitSection';

export const DevKitPage: React.FC = () => {
  return (
    <div className="mx-auto max-w-5xl p-8">
      <h3 className="mt-2 text-center font-bold">Dev Kit</h3>
      <TranslationDevKitSection />
      <AuthOverrideDevKitSection />
      <AuthDevKitSection />
      <EnvOverrideDevKitSection />
      <DevKitSection title="Environment">
        <pre>{JSON.stringify(typedEnv, null, 2)}</pre>
      </DevKitSection>
    </div>
  );
};
